import type { Route } from '@atlassian/react-resource-router';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { ProjectsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { onboardingFlowCompletedResource } from '@jira/router-resources__software-onboarding/src/onboardingFlowCompletedResource.tsx';
import { csmProjectsDirectoryRoute } from '@jira/router-routes__directories-routes/src/csmProjectsDirectoryRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { CsmProjectsDirectoryPageEntryPoint } from './common/CsmProjectsDirectoryPageEntryPoint.tsx';

export const csmProjectsDirectoryRouteEntry: Route = createEntry(csmProjectsDirectoryRoute, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? CsmProjectsDirectoryPageEntryPoint
			: notFoundPageEntrypoint;
	},
	skeleton: ProjectsDirectorySkeleton,
	navigation: {
		sidebarId: SidebarIdCsmApp,
	},
	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getNavigationResources({ isUsingSidebarEntrypoint: true }),
		onboardingFlowCompletedResource,
	],
	ufoName: 'csm-projects-directory',
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
